import { render, staticRenderFns } from "./sfdr.vue?vue&type=template&id=8f1a5596&scoped=true&lang=pug"
import script from "./sfdr.vue?vue&type=script&lang=ts"
export * from "./sfdr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1a5596",
  null
  
)

export default component.exports